// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".package_title[data-v-4b744439]{font-weight:bolder}.package_info[data-v-4b744439],.package_title[data-v-4b744439]{font-family:Consolas,Menlo,Bitstream Vera Sans Mono,Monaco,微软雅黑,monospace}.package_info[data-v-4b744439]{margin-left:20px}", ""]);
// Exports
module.exports = exports;
